import { CaseSelect } from '@/forms/serviceTicket/create/fields/CaseSelect';
import { LocationSelect } from '@/forms/serviceTicket/create/fields/LocationSelect';
import { Box, Grid, Typography } from '@mui/material';
import type { Control, FieldErrors, UseFormSetValue, UseFormWatch } from 'react-hook-form';
import { Link } from 'react-router-dom';

import type { ServiceTicketCreateSchemaType } from '../schema';

interface CaseOrLocationSectionProps {
  control: Control<ServiceTicketCreateSchemaType>;
  errors: FieldErrors<ServiceTicketCreateSchemaType>;
  setValue: UseFormSetValue<ServiceTicketCreateSchemaType>;
  watch: UseFormWatch<ServiceTicketCreateSchemaType>;
}

export const CaseOrLocationSection = ({
  control,
  errors,
  setValue,
  watch,
}: CaseOrLocationSectionProps) => {
  const watchedCaseId = watch('case_id');

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <CaseSelect control={control} errors={errors} />
          <Typography variant="caption" sx={{ mt: 0.5, display: 'block' }}>
            <Link to="/cases/create" style={{ color: 'inherit', textDecoration: 'underline' }}>
              Create a new case
            </Link>
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <LocationSelect
            control={control}
            errors={errors}
            disabled={!!watchedCaseId}
            label={watchedCaseId ? 'Location (from case)' : 'Location *'}
            setValue={setValue}
            watch={watch}
            watchedCaseId={watchedCaseId}
          />
        </Grid>
      </Grid>
    </Box>
  );
};
